import { render, staticRenderFns } from "./ServicesHomeTwo.vue?vue&type=template&id=a440cf3a"
import script from "./ServicesHomeTwo.vue?vue&type=script&lang=js"
export * from "./ServicesHomeTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports